import { Link } from "react-router-dom";
import "../components/navbar.css";
function Navbar() {
  return (
    <>
      <nav
        style={{ borderRadius: "40px" }}
        id="top_nav"
        className="navbar navbar-expand-lg navbar-light sticky-top"
      >
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navbar Links */}
          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav w-100 d-flex justify-content-evenly">
              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/abstract">
                  Abstract
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/intro">
                  Introduction
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/SAM">
                  Materials & Methods
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/RAD">
                  Results & Discussion
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/conclusion">
                  Conclusion
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link underline-hover" to="/cite">
                  Citation
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link underline-hover"
                  href="images/article/article_pdf.pdf"
                >
                  PDF
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
export default Navbar;
